import useAuth from 'hooks/useAuth.ts';
import { FeatureFlag } from 'types/features';

type FeatureActions = {
    isFlowEnabled: boolean;
    isFlowDisabled: boolean;
};

export const useFeatureFlags = (
    requiredFeature: FeatureFlag | FeatureFlag[] | undefined,
    requireAll = false
): FeatureActions => {
    const { user } = useAuth();
    const enabledFeatures = user?.enabledFeatures;
    if (!requiredFeature) {
        return {
            isFlowEnabled: true,
            isFlowDisabled: false,
        };
    }

    if (!enabledFeatures) {
        return {
            isFlowEnabled: false,
            isFlowDisabled: true,
        };
    }

    const requiredFeatures = Array.isArray(requiredFeature) ? requiredFeature : [requiredFeature];
    const isFlowEnabled = requireAll
        ? requiredFeatures.every((feature) => enabledFeatures.includes(feature))
        : requiredFeatures.some((feature) => enabledFeatures.includes(feature));
    const isFlowDisabled = !isFlowEnabled;

    return {
        isFlowEnabled,
        isFlowDisabled,
    };
};

/**
 *
 * @param {(FeatureFlag | FeatureFlag[])} requiredFeature
 * @param {Boolean} requireAll whether all feature flags provided need to match
 * @returns {Boolean}
 */
export const useIsFeatureEnabled = (requiredFeature: FeatureFlag | FeatureFlag[], requireAll = false): boolean => {
    const { user } = useAuth();
    const enabledFeatures = user?.enabledFeatures;
    const requiredFeatures = Array.isArray(requiredFeature) ? requiredFeature : [requiredFeature];
    if (enabledFeatures == undefined || requiredFeature === undefined || requiredFeature === null) {
        return false;
    } else if (requiredFeatures.length === 0) {
        return true;
    } else {
        return requireAll
            ? requiredFeatures.every((feature) => enabledFeatures.includes(feature))
            : requiredFeatures.some((feature) => enabledFeatures.includes(feature));
    }
};
